import { render, staticRenderFns } from "./ModalAddResource.vue?vue&type=template&id=5b89ef23&"
import script from "./ModalAddResource.vue?vue&type=script&lang=js&"
export * from "./ModalAddResource.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddResource.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports